// Document types that carry no information — node-placed uploads get these as
// neutral defaults, so they must not end up in the displayed/downloaded name.
const GENERIC_DOCUMENT_TYPES = new Set([
  'document',
  'general',
  'unknown document type',
  'unknown folder type',
]);

/** Split "report.final.pdf" into { stem: "report.final", ext: ".pdf" }. */
function splitExtension(fileName: string): { stem: string; ext: string } {
  const dot = fileName.lastIndexOf('.');
  if (dot <= 0 || dot === fileName.length - 1) return { stem: fileName, ext: '' };
  return { stem: fileName.slice(0, dot), ext: fileName.slice(dot) };
}

export function formatDocumentDisplayName(params: {
  cmsNumber?: string | null;
  originalFileName?: string | null;
  documentType?: string | null;
}): string {
  const normalize = (value: string | null | undefined) =>
    (value ?? '')
      .toString()
      .trim()
      .replace(/\s+/g, '_');

  const cms = normalize(params.cmsNumber);
  const baseName = normalize(params.originalFileName);
  const docTypeRaw = normalize(params.documentType);
  const docType = GENERIC_DOCUMENT_TYPES.has(docTypeRaw.replace(/_/g, ' ').toLowerCase())
    ? ''
    : docTypeRaw;

  // Always prefer the original uploaded file name as the core.
  if (!baseName) {
    // Fallback to "cms_documentType" if there's no original name.
    if (cms && docType) return `${cms}_${docType}`;
    if (cms) return cms;
    if (docType) return docType;
    return '';
  }

  // Build "cms_documentName_documentType.ext" while skipping empty parts. The
  // extension stays last so the downloaded file opens in the right app.
  const { stem, ext } = splitExtension(baseName);
  const parts: string[] = [];
  if (cms) parts.push(cms);
  parts.push(stem);
  if (docType) parts.push(docType);

  return `${parts.join('_')}${ext}`;
}
